// extracted by mini-css-extract-plugin
module.exports = {"questionPart":"styles_questionPart__2FOoS","forDots":"styles_forDots__2znSE","editRow":"styles_editRow__HmtJZ","skipped":"styles_skipped__3ysNg","spin":"styles_spin__Fv1Xd"};